import { useState, useEffect } from 'react';

export const useLocalStorage = (key) => {
  const [value, setValue] = useState(() => {
    if (localStorage.getItem(key) === 'undefined') {
      return null;
    }

    const savedValue = localStorage.getItem(key);

    return savedValue;
  });

  useEffect(() => {
    if (key) {
      const savedValue = localStorage.getItem(key);
      setValue(savedValue);
    }
  }, [key]);

  const setValueAndLocalStorage = (newValue) => {
    localStorage.setItem(key, JSON.stringify(newValue));
    setValue(newValue);
  };

  return [value, setValueAndLocalStorage];
};
